/*
 * Petite Lune - reglas de personalización (borrador 12-10).
 * Fuente: fichas de WordPress (WAPF), iguales en los 12 productos personalizables:
 *   - máximo de caracteres (espacios y puntos incluidos): 9 en general y 14 en los
 *     Memory Journal, confirmado por Stefany el 14/10; editable en Ajustes del tema;
 *   - tamaño de letra: mayúscula pequeña;
 *   - tipo de letra: cursiva o clásica;
 *   - +S/ 11 y política de personalización obligatoria.
 * Política de personalización (WordPress, migrada a Shopify): no se graban Ñ, números ni
 * signos distintos del punto; solo hay 3 letras iguales en el taller.
 * Reunión 11-10: la letra clásica va solo en MAYÚSCULAS.
 * Trabaja sobre los campos que dibuja Live Product Options (.cl-po--option).
 */
(function () {
  if (window.plPersonalizacion) return;
  window.plPersonalizacion = true;

  // Límites editables en Ajustes del tema → Personalización Petite Lune (ver layout/theme.liquid).
  var CFG = window.plPz || {};
  var MAX = +CFG.max || 9;
  var FIELD = '.cl-po--option input[type=text], .cl-po--option textarea';
  var FONT = '.cl-po--font-selector select';
  var busy = false;

  function isClasica() {
    var s = document.querySelector(FONT);
    return !!s && /tinos|time new roman|cl[aá]sic/i.test(s.value);
  }

  var REPEAT = +CFG.repeat || 3;

  // Solo letras A-Z, espacios y punto. Las tildes se quitan (Á -> A); la Ñ no se graba.
  function sanitize(value, clasica) {
    var v = value.replace(/[ñÑ]/g, '');
    v = v.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    v = v.replace(/[^A-Za-z. ]/g, '');
    v = v.replace(/ {2,}/g, ' ').replace(/^ +/, '');
    if (clasica) v = v.toUpperCase();
    // Máximo 3 letras iguales (sin distinguir mayúsculas).
    var seen = {}, out = '';
    for (var i = 0; i < v.length; i++) {
      var ch = v[i], k = ch.toLowerCase();
      if (/[a-z]/.test(k)) {
        seen[k] = (seen[k] || 0) + 1;
        if (seen[k] > REPEAT) continue;
      }
      out += ch;
    }
    return out.slice(0, MAX);
  }

  function repeated(v) {
    var c = {}, s = v.toLowerCase().replace(/[^a-z]/g, '');
    for (var i = 0; i < s.length; i++) { c[s[i]] = (c[s[i]] || 0) + 1; if (c[s[i]] > REPEAT) return true; }
    return false;
  }

  function ui(input) {
    if (input.dataset.plReady) return input._pl;
    input.dataset.plReady = '1';
    input.maxLength = MAX;
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('spellcheck', 'false');
    var id = input.id || ('pl-pz-' + Math.random().toString(36).slice(2, 8));
    input.id = id;

    var help = document.createElement('p');
    help.className = 'pl-pz-help';
    help.id = id + '-help';
    help.innerHTML =
      'Máx. ' + MAX + ' caracteres, incluidos espacios y puntos. Sin Ñ ni números; máx. 3 letras iguales.' +
      ' <span class="pl-pz-count" aria-live="polite" id="' + id + '-count"></span>';

    var err = document.createElement('p');
    err.className = 'pl-pz-error';
    err.id = id + '-error';
    err.setAttribute('role', 'alert');
    err.hidden = true;

    input.insertAdjacentElement('afterend', err);
    input.insertAdjacentElement('afterend', help);
    input.setAttribute('aria-describedby', help.id + ' ' + err.id);
    input._pl = { help: help, err: err, count: help.querySelector('.pl-pz-count') };
    return input._pl;
  }

  function showError(parts, text) {
    parts.err.textContent = text;
    parts.err.hidden = !text;
    clearTimeout(parts.t);
    if (text) parts.t = setTimeout(function () { parts.err.hidden = true; }, 4000);
  }

  function apply(input, fromBlur) {
    if (busy) return;
    var parts = ui(input);
    var before = input.value;
    var clasica = isClasica();
    var next = sanitize(before, clasica);
    if (fromBlur) next = next.replace(/ +$/, '');

    var removed = before.replace(/ {2,}/g, ' ').replace(/^ +/, '');
    if (fromBlur) removed = removed.replace(/ +$/, '');
    if (clasica) removed = removed.toUpperCase();
    var stripped = removed.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    if (/[ñÑ]/.test(removed)) {
      showError(parts, 'No podemos grabar la Ñ. Prueba con N o con tus iniciales.');
    } else if (stripped.replace(/[^A-Za-z. ]/g, '') !== stripped) {
      showError(parts, 'Solo letras, espacios y punto. Sin números ni otros símbolos.');
    } else if (repeated(removed)) {
      showError(parts, 'Solo tenemos 3 letras iguales para grabar. Prueba con otro nombre o tus iniciales.');
    } else if (removed.length > MAX) {
      showError(parts, 'Máximo ' + MAX + ' caracteres.');
    }

    if (next !== before) {
      var pos = Math.max(0, (input.selectionStart || next.length) - (before.length - next.length));
      busy = true;
      input.value = next;
      try { input.setSelectionRange(pos, pos); } catch (e) {}
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      busy = false;
    }
    parts.count.textContent = input.value.length + '/' + MAX;
    input.classList.toggle('pl-pz-full', input.value.length >= MAX);
  }

  function all() {
    document.querySelectorAll(FIELD).forEach(function (i) { apply(i, false); });
  }

  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches(FIELD)) apply(e.target, false);
  }, true);
  document.addEventListener('focusout', function (e) {
    if (e.target.matches && e.target.matches(FIELD)) apply(e.target, true);
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches(FONT)) {
      setTimeout(all, 80);
      setTimeout(all, 400);
    }
  }, true);

  var q;
  new MutationObserver(function () {
    clearTimeout(q);
    q = setTimeout(function () {
      document.querySelectorAll(FIELD).forEach(function (i) { if (!i.dataset.plReady) apply(i, false); });
    }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
})();
